// extracted by mini-css-extract-plugin
export default {"container":"Jj-z","blurb":"Kj-z","links":"Lj-z"};